import { render } from "./CanteenModule.vue?vue&type=template&id=378fe325&scoped=true"
import script from "./CanteenModule.vue?vue&type=script&lang=js"
export * from "./CanteenModule.vue?vue&type=script&lang=js"

import "./CanteenModule.vue?vue&type=style&index=0&id=378fe325&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-378fe325"

export default script